export enum AuthenticationMode {
  EmailAndPassword = 0,
  NeedRegistration = 1,
  Sso = 2,
}
